import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PorscheDesignSystemModule } from '@porsche-design-system/components-angular';
import { ErrorBannerComponent } from './shared/components/error-banner/error-banner.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { NavbarComponent } from './shared/components/navbar/navbar.component';
import { SnowComponent } from './shared/components/snow/snow.component';
import { ThemeLoaderComponent } from './shared/components/theme-loader/theme-loader.component';
import { HolidayService } from './shared/services/holiday.service';

@Component({
  selector: 'opa-root',
  imports: [
    PorscheDesignSystemModule,
    RouterOutlet,
    ThemeLoaderComponent,
    HeaderComponent,
    NavbarComponent,
    ErrorBannerComponent,
    SnowComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly isChristmas = inject(HolidayService).isChristmas();
}
